import React from 'react';
import store from './store';
import * as actions from './store/actions/index';
import Input from './components/Input';
import Auth from './lib/auth';
import {
  AuthenticationDetails,
  CognitoUser,
  CognitoUserPool,
} from 'amazon-cognito-identity-js';
import config from './config';

export default class LoginRegister extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      refreshing: false,
      newPasswordRequired: false,
      mfaRequired: false,
      forgotPasswordRequired: false,
      newPassword: null,
      email: null,
      password: null,
      remember: true,
      mfaCode: null,
    };

    this.doLogin = this.doLogin.bind(this);
    this.doForgotPassword = this.doForgotPassword.bind(this);
    this.doSetPasswordFromForgotPassword = this.doSetPasswordFromForgotPassword.bind(
        this);
  }

  handleFormChange(name, e) {
    this.setState({[name]: e.target.value});
  }

  handleCheckboxChange(name, e) {
    this.setState({[name]: e.target.checked});
  }

  doLogin(e) {
    e.preventDefault();
    this.setState({loading: true});
    Auth.login({
      email: this.state.email,
      password: this.state.password,
      remember: this.state.remember,
      newPassword: this.state.newPassword,
      mfaCode: this.state.mfaCode,
    }).then((result) => {
      if (result.newPasswordRequired) {
        this.setState({newPasswordRequired: true, loading: false});
      } else if (result.mfaRequired) {
        this.setState({mfaRequired: true, loading: false});
      } else {
        this.setState({refreshing: true});
        window.location.reload();
      }
    }).catch((error) => {
      alert(error.message);
      this.setState({loading: false});
    });
  }

  doForgotPassword(e) {
    e.preventDefault();
    let email = this.state.email;
    if (!email) {
      alert('Please enter your email address on the field');
      return;
    }

    this.setState({loading: true});

    Auth.forgotPassword(email).then(result => {
      console.log(result);
      this.setState({loading: false, forgotPasswordRequired: true});
    }).catch(err => {
      alert(err.message);
      console.error(err);
      this.setState({loading: false});
    });

  }

  doSetPasswordFromForgotPassword(e) {
    e.preventDefault();

    this.setState({loading: true});
    Auth.setPasswordFromForgotPassword(this.state.mfaCode,
        this.state.newPassword).then(result => {
      alert('Success!');
      this.setState({refreshing: true});
      window.location.reload();
    }).catch(err => {
      alert(err.message);
      console.error(err);

      this.setState({loading: false});
    });
  }

  renderLoading() {
    return (
        <div
            className="d-flex flex-column align-items-center justify-content-center"
            style={{
              height: '100vh',
            }}>
          <img src={process.env.PUBLIC_URL + '/img/logo.svg'}
               alt={process.env.REACT_APP_NAME}/>
          <div>
            <i className="fa fa-spinner fa-spin"
               style={{fontSize: '2rem', marginTop: '10px'}}></i>
          </div>
        </div>
    );
  }

  renderMfa() {
    return (
        <section className="mid-section login-signup">
          <div className="display-table">
            <div className="display-table-cell">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 text-center">
                    <a href="index.html" title="" className="logo login-logo">
                      <img src="/img/logo.svg" alt=""/>
                    </a>
                  </div>
                  <div className="col-md-8 col-lg-6 offset-lg-3 offset-md-2">
                    <div className="login-form">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="login-part">
                            <form
                                onSubmit={this.doLogin}>
                              <div className="row">
                                <div className="col-md-12">
                                  <h3>Verification</h3>
                                </div>
                                <div className="col-md-12">
                                  <label className="label">
                                    <img
                                        src="/img/email-icon.svg"
                                        alt=""/>Verification Code
                                  </label>
                                  <input className="field-wrap"
                                         placeholder="123456"
                                         tabIndex="1"
                                         type="number"
                                         defaultValue={this.state.mfaCode}
                                         onChange={this.handleFormChange.bind(
                                             this, 'mfaCode')}
                                         key="mfaCode"
                                         required/>
                                </div>

                                <div className="col-md-12">
                                  <div className="row">
                                    <div className="col-md-12">
                                      <button className="field-wrap button"
                                              tabIndex="2"
                                              type="submit"
                                      >
                                        Verify
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    );
  }

  renderNewPasswordFromForgotPassword() {
    return (
        <section className="mid-section login-signup">
          <div className="display-table">
            <div className="display-table-cell">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 text-center">
                    <a href="index.html" title="" className="logo login-logo">
                      <img src="/img/logo.svg" alt=""/>
                    </a>
                  </div>
                  <div className="col-md-8 col-lg-6 offset-lg-3 offset-md-2">
                    <div className="login-form">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="login-part">
                            <form
                                onSubmit={this.doSetPasswordFromForgotPassword}>
                              <div className="row">
                                <div className="col-md-12">
                                  <h3>Set New Password</h3>
                                </div>
                                <div className="col-md-12">
                                  <label className="label">
                                    <img
                                        src="/img/email-icon.svg"
                                        alt=""/>Verification Code
                                  </label>
                                  <input className="field-wrap"
                                         placeholder="123456"
                                         tabIndex="1"
                                         type="number"
                                         defaultValue={this.state.mfaCode}
                                         onChange={this.handleFormChange.bind(
                                             this, 'mfaCode')}
                                         key="mfaCode"
                                         required/>
                                </div>

                                <div className="col-md-12">
                                  <label className="label">
                                    <img
                                        src="/img/password-icon.svg"
                                        alt=""/>New Password
                                  </label>
                                  <input className="field-wrap"
                                         placeholder="********"
                                         tabIndex="1"
                                         type="password"
                                         defaultValue={this.state.newPassword}
                                         onChange={this.handleFormChange.bind(
                                             this, 'newPassword')}
                                         key="newPassword"
                                         required/>
                                </div>
                                <div className="col-md-12">
                                  <div className="row">
                                    <div className="col-md-12">
                                      <button className="field-wrap button"
                                              tabIndex="2"
                                              type="submit"
                                              value="Set Password"
                                      >
                                        Save New Password
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    );
  }

  renderNewPassword() {
    return (
        <section className="mid-section login-signup">
          <div className="display-table">
            <div className="display-table-cell">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 text-center">
                    <a href="index.html" title="" className="logo login-logo">
                      <img src="/img/logo.svg" alt=""/>
                    </a>
                  </div>
                  <div className="col-md-8 col-lg-6 offset-lg-3 offset-md-2">
                    <div className="login-form">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="login-part">
                            <form onSubmit={this.doLogin}>
                              <div className="row">
                                <div className="col-md-12">
                                  <h3>Change Password</h3>
                                </div>
                                <div className="col-md-12">
                                  <label className="label">
                                    <img
                                        src="/img/email-icon.svg"
                                        alt=""/>New Password
                                  </label>
                                  <input className="field-wrap"
                                         placeholder="********"
                                         tabIndex="1"
                                         type="password"
                                         defaultValue={this.state.newPassword}
                                         onChange={this.handleFormChange.bind(
                                             this, 'newPassword')}
                                         key="newPassword"
                                         required/>
                                </div>

                                <div className="col-md-12">
                                  <div className="row">
                                    <div className="col-md-12">
                                      <button className="field-wrap button"
                                              tabIndex="2"
                                              type="submit"
                                              value="Set Password"
                                      >
                                        Save New Password
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    );
  }

  renderLogin() {
    return (
        <section className="mid-section login-signup">
          <div className="display-table">
            <div className="display-table-cell">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12 text-center">
                    <a href="index.html" title="" className="logo login-logo">
                      <img src="/img/logo.svg" alt=""/>
                    </a>
                  </div>
                  <div className="col-md-8 col-lg-6 offset-lg-3 offset-md-2">
                    <div className="login-form">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="login-part">
                            <form onSubmit={this.doLogin}>
                              <div className="row">
                                <div className="col-md-12">
                                  <h3>Login</h3>
                                </div>
                                <div className="col-md-12">
                                  <label className="label">
                                    <img
                                        src="/img/email-icon.svg"
                                        alt=""/>Email
                                  </label>
                                  <input className="field-wrap"
                                         placeholder="john@ancileo.com"
                                         tabIndex="1"
                                         type="email"
                                         defaultValue={this.state.email}
                                         onChange={this.handleFormChange.bind(
                                             this, 'email')}
                                         required/>
                                </div>
                                <div className="col-md-12">
                                  <label className="label">
                                    <img
                                        src="/img/password-icon.svg" alt=""/>Password
                                  </label>
                                  <input className="field-wrap"
                                         placeholder="***********"
                                         tabIndex="2"
                                         type="password"
                                         defaultValue={this.state.password}
                                         onChange={this.handleFormChange.bind(
                                             this, 'password')}
                                         key="password"
                                         required/>
                                </div>
                                <div className="col-md-12">
                                  <fieldset>
                                    <input id="option1"
                                           type="checkbox"
                                           name="sign-me"
                                           checked={this.state.remember}
                                           onChange={this.handleCheckboxChange.bind(
                                               this, 'remember')}
                                           tabIndex={3}
                                    />
                                    <label className="checkbox"
                                           htmlFor="option1">
                                      Remember me
                                    </label>
                                  </fieldset>
                                </div>
                                <div className="col-md-12">
                                  <div className="row">
                                    <div className="col-md-6">
                                      <button className="field-wrap button"
                                              tabIndex="4"
                                              type="submit"
                                              value="Login"
                                              disabled={this.state.loading}
                                      >Login
                                      </button>
                                    </div>
                                    <div className="col-md-6">
                                      <a href="#" className="forgot"
                                         style={this.state.loading ? {
                                           opacity: 0.7,
                                           pointerEvents: 'none',
                                         } : null}
                                         onClick={this.doForgotPassword}>Forgot
                                        Password?
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    );
  }

  render() {
    if (this.state.refreshing) {
      return this.renderLoading();
    }
    if (this.state.mfaRequired) {
      return this.renderMfa();
    }
    if (this.state.newPasswordRequired) {
      return this.renderNewPassword();
    }
    if (this.state.forgotPasswordRequired) {
      return this.renderNewPasswordFromForgotPassword();
    }
    return this.renderLogin();

  }

}


// WEBPACK FOOTER //
// ./src/LoginRegister.js